import { DisciplineEnum, type FullInterventionDefinitionViewModel, type InterventionDefinitionViewModel } from '@generated';
import { generateValidationSchema } from '~/libraries/forms/validation';
import Yup from '~/util/yup';
import { isFullInterventionDefinition } from '../util';

export function getInterventionDefinitionValidationSchema(
	interventionDefinition: FullInterventionDefinitionViewModel | InterventionDefinitionViewModel,
	maxEndDate: Date
): Yup.AnySchema {
	const validationSchema = {
		projectedStartDate: Yup.date().label('Start Date').required(),
		projectedEndDate: Yup.date()
			.label('End Date')
			.max(maxEndDate, `Projected end date must come before ${maxEndDate.toLocaleDateString()}`)
			.required(),
		homeHealthAideInterventionFrequencyTypeId: Yup.string()
			.label('HHA Frequency')
			.nullable()
			.when('assignedDisciplineIds', ([assignedDisciplineIds]: number[][], schema) => {
				if (assignedDisciplineIds.includes(DisciplineEnum.HomeHealthAide)) {
					return schema.required('Home Health Aide interventions require a frequency to be set.');
				}
				return schema;
			}),
		assignedDisciplineIds: Yup.array()
			.min(1, 'At least one discipline must be assigned for the intervention to be added.')
			.label('Assigned Discipline')
			.nullable()
			.required()
	};

	if (!isFullInterventionDefinition(interventionDefinition)) {
		return Yup.object().shape(validationSchema);
	}

	if (!interventionDefinition.definitionFormControls || interventionDefinition.definitionFormControls.length === 0) {
		return Yup.object().shape(validationSchema);
	}

	return Yup.object().shape({
		...validationSchema,
		...generateValidationSchema(interventionDefinition.definitionFormFields)
	});
}
